import { capitalizeAllIfLower } from '@btime/helpers'
import { compose, prop } from 'ramda'
import React from 'react'

import { useSaveUserGroup } from './_requests/saveUserGroup'
import GroupsLoader, { useGroups } from '../_load/GroupsLoader'
import LazySelect from '../../../components/form/LazySelect'

const mapOptions = data =>
  data.map(item => ({
    origin: item,
    value: prop('id', item),
    label: compose(capitalizeAllIfLower, prop('name'))(item)
  }))

const GroupsSelect = ({ onChange, canCreate, ...props }) => {
  const onSuccess = result => onChange(result.id, result.name, { origin: result, value: result.id, label: result.name })
  const [onCreate, { loading }] = useSaveUserGroup(onSuccess)

  return (
    <LazySelect
      onChange={onChange}
      Loader={GroupsLoader}
      dataHook={useGroups}
      mapOptions={mapOptions}
      onCreate={canCreate && onCreate}
      loading={loading}
      {...props}
    />
  )
}

export default GroupsSelect
